"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _MerchandiseSelectors = require("../../../selectors/MerchandiseSelectors");

var UnitTypes = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/UnitTypes"));

var MC_LANDING_PAGE_URL = 'https://www.hubspot.com/marketing-contacts/anz';

var IncludedUnitsSubtext = function IncludedUnitsSubtext(_ref) {
  var merchandiseId = _ref.merchandiseId,
      className = _ref.className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var merchUnitType = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.merchUnitTypeSelector)(state, merchandiseId);
  });
  if (!merchUnitType) return null;
  var includedUnits = merchandiseMap[merchandiseId].includedAdditionalUnits;
  var stringKey;
  var messageProps = {
    elements: {
      Number: _FormattedNumber.default
    },
    options: {
      value: includedUnits
    }
  };

  if (merchUnitType === UnitTypes.MARKETING_CONTACT) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.contactsMC_jsx';
    messageProps = {
      elements: {
        Number: _FormattedNumber.default,
        Link: _UILink.default
      },
      options: {
        value: includedUnits,
        href: MC_LANDING_PAGE_URL
      }
    };
  } else if (merchUnitType === UnitTypes.USER) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.users_jsx';
  } else if (merchUnitType === UnitTypes.CONTACT) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.contacts_jsx';
  }

  return _react.default.createElement("div", {
    className: className,
    style: style
  }, _react.default.createElement(_Small.default, {
    use: "help",
    className: "m-right-2"
  }, _react.default.createElement(_FormattedJSXMessage.default, (0, _extends2.default)({
    message: stringKey
  }, messageProps))));
};

var _default = IncludedUnitsSubtext;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/merch-card/IncludedUnitsSubtext.js
// module id = 489
// module chunks = 5 6